import React, { Component } from "react";
import { Steps, Alert } from "antd";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { PostData } from "../../api/service";
import IdCardIdentifyStep from "./IdCardIdentifyStep";
import IdCardForm from "./IdCardForm";
import { CARD_FIELDS, emptyCardForm, DEFAULT_STATE } from "./cardFields";

const { Step } = Steps;

export default class IdCardRequest extends Component {
  state = {
    step: 0,
    form: emptyCardForm(),
    // fields that came back populated from the student record, so the form can
    // highlight only the ones the student actually has to supply
    prefilled: [],
    matched: false,
    isSubmitting: false
  };

  onFound = (resp, roll_no, email) => {
    let form = emptyCardForm();
    let prefilled = [];

    CARD_FIELDS.forEach((f) => {
      let value = resp[f.name];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        // term 0 is not a real term — leave the select empty so it must be picked
        if (f.name === "term" && parseInt(value, 10) < 1) {
          return;
        }
        form[f.name] = String(value);
        prefilled.push(f.name);
      }
    });

    form.roll_no = roll_no;
    form.email = email;

    if (form.state === "") {
      form.state = DEFAULT_STATE;
    }

    this.setState({ step: 1, form, prefilled, matched: true });
  };

  onSkip = (roll_no, email) => {
    let form = emptyCardForm();
    form.roll_no = roll_no;
    form.email = email;

    this.setState({ step: 1, form, prefilled: [], matched: false });
  };

  onFieldChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    });
  };

  onSubmit = (payload) => {
    this.setState({ isSubmitting: true });

    PostData("/add-id-card-request", payload)
      .then((resp) => {
        this.setState({ isSubmitting: false });

        if (resp && resp.status === true) {
          confirmAlert({
            title: "Successfully Submitted ! Proceed to Payment Now.",
            message: "You will now be taken to the payment page.",
            buttons: [
              {
                label: "Proceed to Payment",
                onClick: () => this.goToPayment(resp.id_card_request_id, resp.email)
              }
            ]
          });
        } else if (resp && resp.recaptcha_failed) {
          alert(resp.status_text);
        } else if (resp && resp.id_card_request_id) {
          // an unpaid request already exists for this email + type — send them
          // to that one instead of creating a duplicate
          confirmAlert({
            title: "Previous unsettled request found",
            message: resp.status_text,
            buttons: [
              {
                label: "Proceed to Payment",
                onClick: () => this.goToPayment(resp.id_card_request_id, resp.email)
              }
            ]
          });
        } else {
          alert(resp && resp.status_text ? resp.status_text : "Could not submit your request.");
        }
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
        alert("Something went wrong. Please try again.");
      });
  };

  goToPayment = (id, email) => {
    window.location.href = `/idcard-fees-payment?id_card_request_id=${id}&email=${encodeURIComponent(email)}`;
  };

  render() {
    return (
      <div>
        <Steps current={this.state.step} size="small" style={{ marginBottom: 20 }}>
          <Step title="Identify" />
          <Step title="Card Details" />
          <Step title="Payment" />
        </Steps>

        {this.state.step === 0 && (
          <IdCardIdentifyStep onFound={this.onFound} onSkip={this.onSkip} />
        )}

        {this.state.step === 1 && (
          <div>
            {this.state.matched ? (
              <Alert
                type="success"
                showIcon
                message="We found your record. Please correct anything that is wrong and fill in what is missing."
              />
            ) : (
              <Alert
                type="warning"
                showIcon
                message="We could not match your record, so please fill in all the details yourself. The office will verify them before printing."
              />
            )}
            <br />

            <IdCardForm
              form={this.state.form}
              prefilled={this.state.prefilled}
              isSubmitting={this.state.isSubmitting}
              onFieldChange={this.onFieldChange}
              onSubmit={this.onSubmit}
            />
          </div>
        )}
      </div>
    );
  }
}
